import React, { useCallback, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AdvancedMenuItemComponentProps, setNodeAttr } from '@lyearn/lygo-blocks';
import { Box, Stack, Switch, Typography } from '@lyearn/ui';

function InlinePlayerToggle({ view, currentSelectionNode, pos }: AdvancedMenuItemComponentProps) {
  const { t } = useTranslation('Course');
  const [inlinePlayer, setInlinePlayer] = useState<boolean>(
    currentSelectionNode.attrs.inlinePlayer,
  );

  const onChange = useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      setInlinePlayer(value);
      setNodeAttr(view, pos, 'inlinePlayer', value);
    },
    [view, pos],
  );

  return (
    <Stack direction="col" gapY={24}>
      <Box>
        <Box className="flex items-center justify-between">
          <Typography variant="label-02">
            {t('Course:Builder.InlineExercisePlayer.title')}
          </Typography>
          <Switch checked={inlinePlayer} onChange={onChange} />
        </Box>
        <Typography className="mt-4 text-text-secondary" variant="body-short-03">
          {t('Course:Builder.InlineExercisePlayer.description')}
        </Typography>
      </Box>
    </Stack>
  );
}

export default InlinePlayerToggle;
